import { useContext, useState } from 'react';
import { OrderContext } from '../context/OrderContext';

const useVerifyOtp = () => {
  const { apiClient } = useContext(OrderContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const verifyOtp = async (orderNumber, email, otpCode) => {
    if (!orderNumber || !email || !otpCode) {
      setError('Sipariş numarası, e-posta adresi ve doğrulama kodu gereklidir.');
      return false;
    }

    setLoading(true);
    setError(null);

    try {
      await apiClient.post('api/v1/refund/verify_otp/', {
        order_number: orderNumber,
        email: email,
        otp_code: otpCode,
      });
      return true;
    } catch (err) {
      let msg = 'Doğrulama kodu hatalı.';
      
      if (err.code === 'ECONNABORTED' || err.message?.includes('timeout')) {
        msg = 'İstek zaman aşımına uğradı. Lütfen tekrar deneyin.';
      } else if (err?.response?.data?.error) {
        msg = err.response.data.error;
      } else if (err.message) {
        msg = err.message;
      }
      
      setError(msg);
      // console.error('[useVerifyOtp] Error:', err);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { verifyOtp, loading, error };
};

export default useVerifyOtp;

